 if (!customElements.get('testimonials-slider')) {
   class TestimonialsSlider extends HTMLElement {
     constructor() {
       super();
       this.track = this.querySelector('.slider__track');
       this.currentIndex = 0;
       this.autoplay = parseInt(this.dataset.autoplay, 10) * 1000 || 0;
       this.isDragging = false;
       this.startX = 0;
       this.timer = null;
       this.init();
     }

     init() {
       this.querySelectorAll('[data-index]').forEach((item) => {
         item.addEventListener('click', () => this.goTo(parseInt(item.dataset.index, 10)));
       });

       this.addEventListener('mousedown', (e) => this.dragStart(e));
       window.addEventListener('mousemove', (e) => this.dragMove(e));
       window.addEventListener('mouseup', (e) => this.dragEnd(e));

       this.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
       this.addEventListener('touchmove', (e) => this.dragMove(e), { passive: false });
       this.addEventListener('touchend', (e) => this.dragEnd(e));

       if (this.autoplay > 0) {
         this.startAutoplay();
       }
     }

     dragStart(e) {
       const pageX = e.pageX ?? (e.touches && e.touches[0] && e.touches[0].pageX);
       if (pageX == null) return;

       this.isDragging = true;
       this.startX = pageX;
       this.stopAutoplay();
     }

     dragMove(e) {
       if (!this.isDragging) return;

       const pageX = e.pageX ?? (e.touches && e.touches[0] && e.touches[0].pageX);
       if (pageX == null) return;

       const walk = pageX - this.startX;
       if (Math.abs(walk) > 10 && e.cancelable) {
         e.preventDefault();
       }
     }

     dragEnd(e) {
       if (!this.isDragging) return;

       this.isDragging = false;

       const pageX =
         e?.pageX ??
         (e?.changedTouches && e.changedTouches[0] && e.changedTouches[0].pageX);

       if (pageX == null) return;

       const walk = pageX - this.startX;

       if (walk < -50) {
         this.next();
       } else if (walk > 50) {
         this.prev();
       }

       if (this.autoplay > 0) {
         this.startAutoplay();
       }
     }

     goTo(index) {
       const totalSlides = this.querySelectorAll('.slider__item').length;

       if (index < 0) index = totalSlides - 1;
       if (index >= totalSlides) index = 0;

       this.currentIndex = index;
       this.track.style.transform = `translateX(-${index * 100}%)`;

       this.querySelectorAll('[data-index]').forEach((btn) => {
         btn.classList.toggle('is-active', parseInt(btn.dataset.index, 10) === index);
       });
     }

     next() {
       this.goTo(this.currentIndex + 1);
     }

     prev() {
       this.goTo(this.currentIndex - 1);
     }

     startAutoplay() {
       this.stopAutoplay();
       this.timer = setInterval(() => this.next(), this.autoplay);
     }

     stopAutoplay() {
       if (this.timer) {
         clearInterval(this.timer);
         this.timer = null;
       }
     }
   }

   customElements.define('testimonials-slider', TestimonialsSlider);
 }

